

/** @type {import('./range')} */
module.exports = RangeError;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/range.js
// module id = ../node_modules/es-errors/range.js
// module chunks = 0